// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BmMVM","colMin":"styles_colMin__x-_KR"};